import { render, staticRenderFns } from "./InsightTabs.vue?vue&type=template&id=6571b256&scoped=true"
import script from "./InsightTabs.vue?vue&type=script&lang=js"
export * from "./InsightTabs.vue?vue&type=script&lang=js"
import style0 from "./InsightTabs.vue?vue&type=style&index=0&id=6571b256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571b256",
  null
  
)

export default component.exports